import { PointFeature } from "@evergis/sgis/es/features/PointFeature";
import { Polygon } from "@evergis/sgis/es/features/Polygon";
import { Polyline } from "@evergis/sgis/es/features/Polyline";
import { plain } from "@evergis/sgis/es/Crs";

/**
 * Моки фич для отображения превью символа
 * http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217
 */

export const viewBoxSize = 100;

export const pointFeature = new PointFeature([50, -50], { crs: plain });
export const heartbeatLineFeature = new Polyline(
  [
    [0, -57],
    [26, -57],
    [40, -35],
    [60, -65],
    [74, -43],
    [100, -43],
  ],
  { crs: plain },
);
export const hexagonPolygonFeature = new Polygon(
  [
    [50, -15],
    [80, -33],
    [80, -67],
    [50, -85],
    [20, -67],
    [20, -33],
    [50, -15],
  ],
  { crs: plain },
);

export const directLineFeature = new Polyline(
  [
    [0, -50],
    [100, -50],
  ],
  { crs: plain },
);
export const squarePolygonFeature = new Polygon(
  [
    [0, 0],
    [100, 0],
    [100, -100],
    [0, -100],
  ],
  { crs: plain },
);
